var map = {
	"./1.webp": 3055,
	"./2.png": 5642,
	"./3.png": 3219,
	"./4.webp": 3472,
	"./6.png": 4798,
	"./7.webp": 7181,
	"./8.webp": 8068,
	"./9.webp": 5895
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1800;